module.exports = __webpack_public_path__ + "media/images/application/template/select-arrow-down-e95371e4120abc70bb18d747d98ed9bb.svg";